import { router } from "@inertiajs/vue3";

/**
 * Met à jour l'état InstantSearch UI
 */
export function setInstantSearchUiState(
    instantSearchInstance: any,
    indexName: string,
) {
    return function ({ query }: { query: string }) {
        instantSearchInstance.setUiState((uiState: any) => ({
            ...uiState,
            [indexName]: {
                ...uiState[indexName],
                page: 1,
                query,
            },
        }));
    };
}

/**
 * Met à jour la valeur de l'input visuel directement
 */
export function updateInputValue(identifiant: string) {
    return function (query: string) {
        const input = document.querySelector(
            `#${identifiant} input`,
        ) as HTMLInputElement;
        if (input) {
            input.value = query;
            // Déclencher un événement pour que Vue reactive la valeur
            input.dispatchEvent(new Event("input", { bubbles: true }));
        }
    };
}

/**
 * Navigue vers le marketplace avec une requête
 */
export function toMarketplace({ query }: { query: string }) {
    router.get("/marketplace", { query: query });
}

/**
 * Met à jour l'état Algolia selon la page actuelle
 */
export function updateAlgoliaState(
    page: any,
    instantSearchInstance: any,
    indexName: string,
) {
    return function (item: { label: string }) {
        if (page.component === "Vehicle/Index") {
            instantSearchInstance.setUiState((uiState: any) => ({
                ...uiState,
                [indexName]: {
                    ...uiState[indexName],
                    page: 1,
                    menu: {
                        make: item.label,
                    },
                },
            }));
        } else {
            const queryString = `?menu[make]=${encodeURIComponent(item.label)}`;
            window.location.href = `/marketplace${queryString}`;
        }
    };
}
